import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog } from '@angular/material';
import { BackOfficeHome } from 'src/app/Services/Api.BackOfficeHome/BackOfficeHome';
import { OpenModal } from 'src/app/OpenModal';
import { ServicesCommon } from 'src/app/Services/Api.Common/ServicesCommon';
import { TypeDialog, ButtonsDialog } from 'src/app/model-type';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BilleteraService } from 'src/app/Services/Api.Billetera/BilleteraService';
import { TableUtil } from 'src/tableUtil';
@Component({
  selector: 'app-repote-comisiones-component',
  templateUrl: './repote-comisiones-component.component.html',
  styleUrls: ['./repote-comisiones-component.component.css']
})
export class RepoteComisionesComponentComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['ordenDespachoID','id', 'vendedor', 'tipoDocumento', 'numeroDocumento' ,'cantidadTags','fechaHora']
  dialogRef: any;
  form: FormGroup;

  constructor(private _BackOfficeHome: BilleteraService,
    public dialog: MatDialog, private fb: FormBuilder,
    private OModal: OpenModal) {
    this.form = this.fb.group({
      desde: [new Date(new Date().getTime() - 2592000000)],
      hasta: [(new Date())],
    })
  }

  ngOnInit() {
    this.ObtenerOrdenesDespacho();
  }

  ObtenerOrdenesDespacho() {

    const desde = new Date(this.form.get('desde').value);
    const hasta = new Date(this.form.get('hasta').value);
    const MesDesde = desde.getMonth() + 1;
    let MesForDesde = '';
    let DiaForDesde = '';
    
    const DiaDesde = (desde.getDate()).toString();

    if (DiaDesde.length === 1) {
      DiaForDesde = '0' + DiaDesde.toString();
    } else {
      DiaForDesde = DiaDesde.toString();
    }

    if (MesDesde.toString().length === 1) {
      MesForDesde = '0' + MesDesde.toString();
    } else {
      MesForDesde = MesDesde.toString();
    }

    const fechaDesde = desde.getFullYear().toString() + MesForDesde.toString() + DiaForDesde.toString();


    const MesHasta = hasta.getMonth() + 1;
    let MesForHasta = '';
    let DiaForHasta = '';
    const DiaHasta = hasta.getDate().toString();

    if (DiaHasta.length === 1) {
      DiaForHasta = '0' + DiaHasta.toString();
    } else {
      DiaForHasta = DiaHasta.toString();
    }

    if (MesHasta.toString().length === 1) {
      MesForHasta = '0' + MesHasta.toString();
    } else {
      MesForHasta = MesHasta.toString();
    }

    const fechaHasta = hasta.getFullYear().toString() + MesForHasta.toString() + DiaForHasta.toString();
    this.dataSource.data = [];

    //obtenerOrdenesDespacho
    this._BackOfficeHome.repoteVentas(fechaDesde, fechaHasta ).subscribe(res => {
      //console.log(res);
      console.log(res);

      const record = (res as any).recordset;
      if (record != null) {        
        this.dataSource.data = record;
        this.dataSource.paginator = this.paginator;
      } else {
        this.OModal.openDialog(
          TypeDialog.information,
          "Advertencia",
          "No hay resultados disponibles para el rango de fechas seleccionado.",
          ButtonsDialog.ok,
          300
        );
      }
    });
  }

  exportTable() {
    if(this.dataSource.filter){
    TableUtil.exportArrayToExcel(
      this.dataSource.data.filter((x)=>{
        return JSON.stringify(x).toLowerCase().includes(this.dataSource.filter)}),
      "reporteVentas"
      );
    }
    else
        TableUtil.exportArrayToExcel(
          this.dataSource.data,
          "usuarios"
        );  
    }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
